var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStripe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 90 39",
    style: {
      enableBackground: "new 0 0 90 39"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.str-st0{fill-rule:evenodd;clip-rule:evenodd;fill:#635BFF;}\n\t.str-st1{fill:#635BFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "str-st0",
    d: "M89.5,20.1c0-6.4-3.1-11.4-9-11.4c-5.9,0-9.5,5-9.5,11.3c0,7.5,4.2,11.3,10.3,11.3c3,0,5.2-0.7,6.9-1.6v-5 c-1.7,0.8-3.6,1.4-6.1,1.4c-2.4,0-4.6-0.8-4.8-3.8h12.2C89.5,22,89.5,20.7,89.5,20.1z M77.2,17.8c0-2.8,1.7-4,3.3-4 c1.5,0,3.1,1.2,3.1,4H77.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "str-st0",
    d: "M61.5,8.7c-2.4,0-4,1.1-4.9,1.9l-0.3-1.5h-5.5v29l6.2-1.3l0-7c0.9,0.6,2.2,1.6,4.4,1.6c4.5,0,8.5-3.6,8.5-11.5 C69.9,12.7,65.8,8.7,61.5,8.7z M60,25.9c-1.5,0-2.3-0.5-2.9-1.2l0-9.2c0.6-0.7,1.5-1.2,3-1.2c2.3,0,3.8,2.5,3.8,5.8 C63.8,23.4,62.2,25.9,60,25.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "str-st0",
    d: "M42.2,7.3l6.2-1.3v-5l-6.2,1.3V7.3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "str-st1",
    d: "M48.5,9.2h-6.2v21.8h6.2V9.2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "str-st0",
    d: "M35.5,11l-0.4-1.8h-5.4v21.8H36V16.2c1.5-1.9,4-1.6,4.7-1.3V9.2C39.9,8.9,37,8.3,35.5,11z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "str-st0",
    d: "M23.1,3.8L17,5.1L17,25c0,3.7,2.8,6.4,6.4,6.4c2,0,3.5-0.4,4.4-0.8v-5c-0.8,0.3-4.7,1.5-4.7-2.2v-8.8h4.7V9.2 h-4.7L23.1,3.8z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "str-st0",
    d: "M6.3,15.5c0-1,0.8-1.3,2.1-1.3c1.9,0,4.3,0.6,6.2,1.6V9.9c-2.1-0.8-4.1-1.1-6.2-1.1c-5,0-8.4,2.6-8.4,7 c0,6.9,9.5,5.8,9.5,8.7c0,1.1-1,1.5-2.4,1.5c-2.1,0-4.7-0.8-6.8-2v5.9c2.3,1,4.7,1.4,6.8,1.4c5.2,0,8.7-2.6,8.7-7 C15.8,16.9,6.3,18.3,6.3,15.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStripe);
export default __webpack_public_path__ + "static/media/stripe.32bd4e4de60a223b92e88fd2755f4530.svg";
export { ForwardRef as ReactComponent };